interface SpinnerProps {
  label?: string;
}

export function Spinner({ label = 'Loading' }: SpinnerProps) {
  return <span className="spinner" role="status" aria-label={label} />;
}

export function StateBlock({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="state-block">
      <p className="state-block__title">{title}</p>
      {description ? <p>{description}</p> : null}
      {action}
    </div>
  );
}

/**
 * Numeric table cell. The design shows a small circled "i" after the vendor / contacted /
 * response / completed counts, but hovering it did nothing in the browser, so the icon was
 * dropped and only the value is rendered. The descriptive text stays in the DOM for screen
 * readers (the column header carries the meaning for everyone else).
 */
export function Metric({ value, hint }: { value: number | string; hint: string }) {
  return (
    <span className="metric">
      <span>{value}</span>
      <span className="visually-hidden">{hint}</span>
    </span>
  );
}
